import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Clock } from "lucide-react";
import axios from "axios";
import { API } from "../App";

export const PublicFooter = () => {
  const [pages, setPages] = useState([]);
  const [company, setCompany] = useState({});

  useEffect(() => {
    axios
      .get(`${API}/site/pages`)
      .then((res) => setPages((res.data || []).filter((p) => p.show_in_footer)))
      .catch(() => {});
    axios
      .get(`${API}/site/company`)
      .then((res) => setCompany(res.data || {}))
      .catch(() => {});
  }, []);

  return (
    <footer className="py-10 bg-slate-950 border-t border-slate-800" data-testid="public-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-8">
          <div className="flex items-center gap-2">
            <Clock className="w-5 h-5 text-emerald-400" />
            <span className="text-slate-200 font-semibold">PRC勤怠</span>
          </div>

          <div className="flex flex-wrap gap-x-6 gap-y-2 max-w-md">
            <Link
              to="/guide"
              className="text-sm text-slate-400 hover:text-white transition-colors"
              data-testid="footer-link-guide"
            >
              取扱説明書
            </Link>
            <Link
              to="/estimate"
              className="text-sm text-slate-400 hover:text-white transition-colors"
              data-testid="footer-link-estimate"
            >
              導入見積
            </Link>
            {pages.map((p) => (
              <Link
                key={p.slug}
                to={`/p/${p.slug}`}
                className="text-sm text-slate-400 hover:text-white transition-colors"
                data-testid={`footer-link-${p.slug}`}
              >
                {p.nav_label}
              </Link>
            ))}
          </div>

          <div className="flex flex-col gap-2">
            <Link to="/login" className="text-sm text-slate-300 hover:text-white transition-colors" data-testid="footer-tenant-login">
              管理者ログイン
            </Link>
            <Link to="/saas-admin/login" className="text-sm text-amber-400 hover:text-amber-300 transition-colors" data-testid="footer-saas-login">
              SaaS管理者ログイン
            </Link>
          </div>
        </div>
        <p className="text-xs text-slate-500 mt-8">© {new Date().getFullYear()} PRC勤怠{company.company_name ? ` / ${company.company_name}` : ""}. All rights reserved.</p>
      </div>
    </footer>
  );
};
